import { useQuery } from 'react-query';

import { apiRequest } from '../utils/apiUtils';

export default function useModelfamilies() {
  return useQuery('modelfamilies', () => apiRequest(`/api/modelfamilies`), {
    refetchOnWindowFocus: false,
  });
}
